import { useContext } from 'react';

import type { CartAlertsContextValue } from '../context/CartAlertsContext';
import { CartAlertsContext } from '../context/CartAlertsContext';

const useCartAlerts = (): CartAlertsContextValue =>
  useContext(CartAlertsContext);

export default useCartAlerts;
